module.exports = __webpack_public_path__ + "img/OSDi_header_RZ.a552889b.svg";